<div class="w-full h-full flex flex-col">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-semibold text-gray-900">Gestión de Agentes</h1>
  </div>

  <div class="w-full flex-1">
    <!-- Panel Prompt -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col h-full">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-xl font-bold text-gray-900">Prompt</h2>
        <button [disabled]="!hasChanges" (click)="onSaveClick()"
          [class]="{'opacity-50': !hasChanges, 'cursor-not-allowed': !hasChanges, 'cursor-pointer': hasChanges}"
          class="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-md hover:shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9" />
          </svg>
          Guardar
        </button>
      </div>

      <div class="space-y-4 mb-4">
        <div class="grid grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
            <select [(ngModel)]="selectedTipo" (change)="onTipoChange()"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer">
              @for (tipo of tiposAgente; track tipo) {
              <option [value]="tipo.id">{{ tipo.name }}</option>
              }
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Versión</label>
            <select [(ngModel)]="selectedPromptVersion" [ariaReadOnly]="true" (change)="onVersionChange()"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer">
              @for (version of versiones; track version) {
              <option [value]="version" [ngValue]="version">{{ version }}</option>
              }
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Scoring Mínimo</label>
            <input type="number" min="0" max="100" step="1" [(ngModel)]="selectedMinScore"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
        </div>
      </div>

      <div class="flex-1 flex gap-4">
        <div class="flex-1 flex flex-col">
          <label class="block text-sm font-medium text-gray-700 mb-2">Contenido del Prompt</label>
          <textarea [readonly]="true" [(ngModel)]="promptContent" (ngModelChange)="changeContentPrompt()"
            class="flex-1 w-full px-4 py-3 border border-gray-300 rounded-md bg-slate-50 text-gray-900 font-mono text-sm resize-none cursor-default focus:outline-none focus:ring-0 focus:border-gray-300"
            placeholder="Escribe el prompt aquí..."></textarea>
        </div>

        <div class="flex-1 flex flex-col">
          <label class="block text-sm font-medium text-gray-700 mb-2">Prompt de Reporting</label>
          <textarea [(ngModel)]="promptReporting"
            class="flex-1 w-full px-4 py-3 border border-gray-300 rounded-md bg-slate-50 text-gray-900 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            placeholder="Escribe aquí que necesitas que se reporte cada vez que una llamada no supere el scoring mínimo..."></textarea>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modals -->
<app-modal-confirm [isOpen]="showConfirmModal" [title]="confirmModalTitle" [message]="confirmModalMessage"
  [type]="confirmModalType" [buttons]="confirmButtons" (action)="onConfirmAction($event)">
</app-modal-confirm>

<app-modal-message [isOpen]="showMessageModal" [title]="messageModalTitle" [message]="messageModalMessage"
  [type]="messageModalType" (close)="closeMessageModal()"></app-modal-message>